import { Sort } from '@opensearch-project/opensearch/api/_types/_common';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';

import { Store } from '@/types';

import data from '@/public/ssr-cache.json';

const store = data?.store as Store;

export const OnSaleQueryFilter: QueryContainer = {
  bool: {
    filter: [{ term: { isActive: true } }],
    should: [
      {
        range: {
          customOnSaleValue: { gte: 1024 },
        },
      },
      {
        bool: {
          filter: [
            {
              script: {
                script: {
                  source: "(doc['customOnSaleValue'].value & 4) == 4",
                },
              },
            },
            {
              nested: {
                path: 'customOnSaleSchedule',
                query: {
                  script: {
                    script: {
                      id: 'is_schedule_active',
                      params: {
                        time_zone: store?.timezone,
                      },
                    },
                  },
                },
              },
            },
          ],
        },
      },
    ],
    minimum_should_match: 1,
  },
};

export const DefaultSortingFilter: Sort = [
  {
    id: {
      order: 'asc',
    },
  },
];
